type BookmarkIconProps = {
  className?: string;
  stroke?: string;
};

const BookmarkIcon = ({ className, stroke }: BookmarkIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5 4C5 3.44772 5.44772 3 6 3H18C18.5523 3 19 3.44772 19 4V19.4835C19 20.2014 18.2659 20.6854 17.6061 20.4026L12 18L6.39392 20.4026C5.73405 20.6854 5 20.2014 5 19.4835V4Z"
      stroke={stroke || "#145758"}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default BookmarkIcon;
